import React, { useState } from "react";
import { Layout, Typography, Divider, Button, Card, Upload, Space, message } from "antd";
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { apiCall, apiDownload } from "../utils/Api";
import LayoutHeader from "../layouts/partials/LayoutHeader";

export default function StockTitleUploadPage(props) {

    // Flag to change title and enable excel download
    const { management = false } = props;

    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);

    const downloadInterm = () => {

        apiCall("interm/download", {}, (_status, _result) => {
            if(_status){
                window.open("/pdf/" + _result.progress_report_id)
            } else {
                message.error(_result.error)
            }
        }); 

     
    }

    const onRemove = (_file) => {
        setFileList([]);
    }

    // disables auto sending file. 
    const beforeUpload = (_file) => {
        setFileList([_file]);
        return false;
    }

    const handleUpload = () => {
        setUploading(true);
        apiCall("interm/upload", { file: fileList[0] }, (_status, _result) => {
            if (_status) {
                message.success("File uploaded successfully.")
            } else {
                message.error("Error: " + _result.error);
            }
            setUploading(false);
        })
    }

    return (
        <>
            <Layout className="layout" >
                <LayoutHeader
                    title={(management) ? "Stock Management" : "Stock and Title Uploads"}
                    description="Use this page to upload your stock or title data information for us to process as an alternative to FTP."
                    button={(management) ? <Button onClick={() => downloadInterm()} icon={<small><DownloadOutlined />&nbsp;</small>} type="primary" size="small"><small>Download current OHs</small></Button> : ""}
                />
                <Layout.Content style={{ "padding": "0px" }} >
                    <div style={{ "padding": "20px" }}>
                        <Card>
                            <p>Select a file and click "Start upload"</p>
                            <Space align="start">
                                <Upload multiple={false} onRemove={(_file) => onRemove(_file)} beforeUpload={(_file) => beforeUpload(_file)}>
                                    <Button disabled={(fileList.length > 0)} icon={<UploadOutlined />}>Select file</Button>
                                </Upload>
                                <Button
                                    type="primary"
                                    onClick={handleUpload}
                                    disabled={fileList.length === 0}
                                    loading={uploading}
                                >
                                    {uploading ? 'Uploading' : 'Start upload'}
                                </Button>
                            </Space>
                        </Card>
                    </div>
                </Layout.Content>
            </Layout>
        </>
    )
}